/* Native disclosure controls on mobile; expanded navigation on larger screens. */
(() => {
  if (window.acFooterMenusInitialized) return;
  window.acFooterMenusInitialized = true;
  const mobile = matchMedia('(max-width: 699px)');
  const modes = new WeakMap();

  function sync() {
    document.querySelectorAll('#ac-home-footer [data-ac-footer-menu]').forEach(details => {
      if (modes.get(details) === mobile.matches) return;
      details.open = !mobile.matches;
      const summary = details.querySelector('summary');
      if (mobile.matches) summary.removeAttribute('tabindex');
      else summary.setAttribute('tabindex', '-1');
      modes.set(details, mobile.matches);
    });
  }

  document.addEventListener('click', event => {
    if (!mobile.matches && event.target.closest('#ac-home-footer [data-ac-footer-menu] > summary')) {
      event.preventDefault();
    }
  });
  mobile.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', sync);
  sync();
})();
